import {
  isValidCoordinate,
  toLatLng,
} from "../../../../utils/maps/MapHelperFunctions";
import type { IRunway } from "../../../osm-maps/map-markers/runway-markers/RunwayMarkers";
import RunwayMarker from "./RunwayMarker";

interface RunwayMarkersProps {
  airportCode: string;
  runwayData: IRunway[];
}

const RunwayMarkers: React.FC<RunwayMarkersProps> = ({
  airportCode,
  runwayData,
}) => (
  <>
    {runwayData.map((runway) => {
      if (
        !isValidCoordinate(runway.startLocation) ||
        !isValidCoordinate(runway.endLocation)
      ) {
        return null;
      }

      return (
        <RunwayMarker
          key={runway.id}
          airportCode={airportCode}
          runwayId={runway.id}
          runwayName={runway.name}
          start={toLatLng(runway.startLocation)}
          end={toLatLng(runway.endLocation)}
          rscInfo={runway.rsc}
          status={[
            runway.rsc.current?.segments[0]?.status,
            runway.rsc.current?.segments[1]?.status,
            runway.rsc.current?.segments[2]?.status,
          ]}
        />
      );
    })}
  </>
);

export default RunwayMarkers;
